// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Auth {
  position: relative;
  width: 100%;
  height: 100vh;
}
.Auth__bgLayer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(14, 14, 14, 0.6);
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.Auth__opacityLayer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(14, 14, 14, 0.6);
  z-index: 1;
}
.Auth__logo {
  display: none;
}
@media (min-width: 400px) {
  .Auth__logo {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 2em;
  }
  .Auth__logo--img {
    width: 100%;
    max-width: 160px;
  }
}
.Auth__content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  max-width: 90%;
  padding: 2em 1.8em;
  border-radius: 8px;
  background-color: rgba(3, 3, 3, 0.75);
}
@media (min-width: 400px) {
  .Auth__content {
    padding: 2.25em 2em;
  }
}
@media (min-width: 640px) {
  .Auth__content {
    padding: 3.75em 3em;
  }
}
@media (min-width: 768px) {
  .Auth__content {
    max-width: 500px;
  }
}
.Auth__content--title {
  font-size: 1.2rem;
  margin-bottom: 1em;
}
@media (min-width: 400px) {
  .Auth__content--title {
    font-size: 1.5rem;
  }
}
.Auth__content--divider {
  margin: 1.5em;
  border-color: #777777;
}
.Auth__content--toggleView {
  display: inherit;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #747474;
  text-align: center;
}
.Auth__content--toggleView .toggler {
  display: inline-block;
  color: #e50914;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  transition: all 0.2s ease-out;
}
.Auth__content--toggleView .toggler:hover {
  color: rgb(204.4642857143, 8.0357142857, 17.8571428571);
  transform: scale(0.95);
}
@media (min-width: 768px) {
  .Auth__content--toggleView .toggler {
    font-size: 16px;
  }
}
@media (min-width: 768px) {
  .Auth__content--toggleView {
    font-size: 16px;
  }
}
.Auth__content--disclaimer {
  display: inherit;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
  color: #e50914;
  text-align: center;
  margin-top: 1.5em;
}
.Auth__content--errors {
  display: inherit;
  margin-top: 1.5em;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: orange;
  text-align: center;
}
@media (min-width: 768px) {
  .Auth__content--errors {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/pages/Auth/auth.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACFA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AAIJ;AAFI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,UAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAIR;AADI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,UAAA;AAGR;AAAI;EACI,aAAA;AAER;AD0CQ;EC7CJ;IAGQ,cAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,UAAA;IACA,YAAA;EAIV;EAFU;IACI,WAAA;IACA,gBAAA;EAId;AACF;AAAI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;AAER;ADgBQ;EC5BJ;IAaQ,mBAAA;EAGV;AACF;ADWQ;EC5BJ;IAiBQ,mBAAA;EAIV;AACF;ADMQ;EC5BJ;IAqBQ,gBAAA;EAKV;AACF;AAHQ;EACI,iBAAA;EACA,kBAAA;AAKZ;ADHQ;ECJA;IAKQ,iBAAA;EAMd;AACF;AAHQ;EACI,aAAA;EACA,qBAAA;AAKZ;AAFQ;EACI,gBAAA;EACA,gCChFA;EDiFA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAIZ;AAFY;EACI,qBAAA;EACA,cC5FV;ED6FU,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAIhB;AAFgB;EACI,uDAAA;EACA,sBAAA;AAIpB;ADjCQ;ECkBI;IAeQ,eAAA;EAIlB;AACF;ADtCQ;ECUA;IA4BQ,eAAA;EAId;AACF;AADQ;EACI,gBAAA;EACA,gCChHA;EDiHA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCxHN;EDyHM,kBAAA;EACA,iBAAA;AAGZ;AAAQ;EACI,gBAAA;EACA,iBAAA;EACA,gCC5HA;ED6HA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAEZ;AD9DQ;ECqDA;IAUQ,eAAA;EAGd;AACF","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n.Auth {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n\n    &__bgLayer {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        background-color: rgba(14, 14, 14, 0.6);\n        z-index: 0;\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-position: center;\n    }\n\n    &__opacityLayer {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        background-color: rgba(14, 14, 14, 0.6);\n        z-index: 1;\n    }\n\n    &__logo {\n        display: none;\n        @include mq(xs) {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            z-index: 2;\n            padding: 2em;\n\n            &--img {\n                width: 100%;\n                max-width: 160px;\n            }\n        }\n    }\n\n    &__content {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        z-index: 2;\n        width: 100%;\n        max-width: 90%;\n        padding: 2em 1.8em;\n        border-radius: 8px;\n        background-color: rgba($color: $pure-black, $alpha: 0.75);\n\n        @include mq(xs) {\n            padding: 2.25em 2em;\n        }\n\n        @include mq(sm) {\n            padding: 3.75em 3em;\n        }\n\n        @include mq(md) {\n            max-width: 500px;\n        }\n\n        &--title {\n            font-size: 1.2rem;\n            margin-bottom: 1em;\n\n            @include mq(xs) {\n                font-size: 1.5rem;\n            }\n        }\n\n        &--divider {\n            margin: 1.5em;\n            border-color: #777777;\n        }\n\n        &--toggleView {\n            display: inherit;\n            font-family: $main-font;\n            font-size: 14px;\n            line-height: 1.4;\n            color: #747474;\n            text-align: center;\n\n            .toggler {\n                display: inline-block;\n                color: $red;\n                font-weight: bold;\n                font-size: 14px;\n                line-height: 1.4;\n                cursor: pointer;\n                transition: all 0.2s ease-out;\n\n                &:hover {\n                    color: darken($red, 5);\n                    transform: scale(0.95);\n                }\n\n                @include mq(md) {\n                    font-size: 16px;\n                }\n            }\n\n            @include mq(md) {\n                font-size: 16px;\n            }\n        }\n\n        &--disclaimer {\n            display: inherit;\n            font-family: $main-font;\n            font-size: 14px;\n            line-height: 1.4;\n            font-weight: 600;\n            color: $red;\n            text-align: center;\n            margin-top: 1.5em;\n        }\n\n        &--errors {\n            display: inherit;\n            margin-top: 1.5em;\n            font-family: $main-font;\n            font-size: 14px;\n            line-height: 1.4;\n            color: orange;\n            text-align: center;\n\n            @include mq(md) {\n                font-size: 16px;\n            }\n        }\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
